import {
  type EventAttributeSet,
  EventAttributeType,
} from "../../EventAttributeSet";

import { type AttributeValue } from "@/schemas/attribute/AttributeSet";
import { attributeListToMap } from "@/utils/attributes";

export enum EventLocation {
  HONGKONG = "HK",
  TAIWAN = "TW",
  THAILAND = "TH",
  VIETNAM = "VN",
  SOUTH_KOREA = "KR",
  PHILIPPINES = "PH",
  USA = "US",
}

const EVENT_LOCATION_VALUES: ReadonlyArray<AttributeValue> = [
  { id: EventLocation.HONGKONG, label: "Hong Kong", iconLabel: "🇭🇰" },
  { id: EventLocation.TAIWAN, label: "Taiwan", iconLabel: "🇹🇼" },
  { id: EventLocation.THAILAND, label: "Thailand", iconLabel: "🇹🇭" },
  { id: EventLocation.VIETNAM, label: "Vietnam", iconLabel: "🇻🇳" },
  { id: EventLocation.SOUTH_KOREA, label: "South Korea", iconLabel: "🇰🇷" },
  { id: EventLocation.PHILIPPINES, label: "Philippines", iconLabel: "🇵🇭" },
  { id: EventLocation.USA, label: "USA", iconLabel: "🇺🇸" },
];

export const EventLocationSet: EventAttributeSet = {
  id: EventAttributeType.LOCATION,
  isMultiSelect: true,
  map: attributeListToMap(EVENT_LOCATION_VALUES),
} as const;
